






















































































import { Component, Ref } from "vue-property-decorator";
import { Link } from "#/types";
import PatientHeader from "@/components/patient/PatientHeader.vue";
import BaseReportList from "@/components/patient/BaseReportList.vue";
import BaseRecord2List, { ListItems } from "@/components/list/baseRecord2List";
import Record3List from "@/views/patient/record2/Record3List.vue";
import { SortWarekiDate } from "#/utility/appSort";

@Component({
  components: {
    PatientHeader,
    BaseReportList,
    Record3List
  }
})
export default class Record2List extends BaseRecord2List {
  @Ref("reportList") private readonly reportList?: BaseReportList;

  private patientId = "";

  /** 上位タブ 0:記録書Ⅱ 1:記録書Ⅲ */
  private viewTab = 0;

  /** サイドメニュー（記録書Ⅱ / 記録書Ⅲ）
   *  記録書Ⅲ は事業所設定の包括型フラグ ON のときのみ活性（patientMaster から判定） */
  private get sidebarLinks(): Link[] {
    return [
      { text: "看護記録Ⅱ", key: "record2" },
      {
        text: "看護記録Ⅲ",
        key: "record3",
        disabled:
          this.patientMaster.office_settings.medical_comprehensive_flg !== 1
      }
    ];
  }

  /** 現在有効なサイドメニュー項目 */
  private get activeLink(): Link {
    return this.sidebarLinks[this.viewTab];
  }

  private headers = [
    {
      text: "訪問者",
      value: "visit_staff_name",
      width: "150px"
    },
    {
      text: "訪問日時",
      value: "visit_date_time",
      width: "230px",
      sort: SortWarekiDate
    },
    {
      text: "記入者",
      value: "create_staff_name",
      width: "150px"
    }
  ];

  private commentHeader = {
    text: "コメント",
    value: "remand_comment"
  };

  private submitHeaders = [
    {
      text: "提出日",
      value: "submit_date_time",
      width: "160px",
      sort: SortWarekiDate
    }
  ];

  /** 最後に検索したタブ */
  private searchedTab = 0;

  created(): void {
    this.patientId = this.$route.params.id;
    // URL クエリからタブを初期化
    if (
      this.$route.query.view === "3" &&
      this.patientMaster.office_settings.medical_comprehensive_flg === 1
    ) {
      this.viewTab = 1;
    }
    if (
      this.viewTab === 0 &&
      (!this.$route.query.reporttab || this.$route.query.reporttab === "0")
    ) {
      this.fetchRecord2({ tab: 0, page: 0 });
    }
  }

  /** サイドメニュークリック（記録書Ⅱ ⇔ 記録書Ⅲ） */
  private onSideBarClick({ index }: { link: Link; index: number }): void {
    this.viewTab = index;
    // 記録書Ⅱタブ選択時のみ記録書Ⅱ一覧を取得
    if (index === 0 && this.records.length === 0) {
      this.fetchRecord2({ tab: this.searchedTab, page: 0 });
    }
    const nextView = index === 1 ? "3" : "2";
    if (this.$route.query.view !== nextView) {
      this.$router.replace({ query: { ...this.$route.query, view: nextView } });
    }
  }

  mounted() {
    this.setDefaultHeader();
  }

  /** タブが切り替わった時 */
  private updateTab(obj: { tab: number; page: number }) {
    this.searchedTab = obj.tab;
    this.fetchRecord2(obj);
  }

  // 一覧取得
  private fetchRecord2(obj: { tab: number; page: number }) {
    this.postJsonCheck(
      window.base_url + "/api/patient/visitrecords/get",
      {
        patient_id: Number(this.patientId),
        tab: obj.tab,
        page: obj.page
      },
      res => {
        if (res.data.records != null) {
          this.reportList?.finishLoaded(res.data.records);
          if (obj.page != 0) {
            this.records = this.records.concat(res.data.records);
          } else {
            this.records = res.data.records;
          }
        } else {
          this.reportList?.finishLoaded([]);
        }
      }
    );
  }

  // 新規作成
  private clickNew() {
    this.$router.push({
      name: "PatientRecord2Edit",
      params: { id: String(this.patientId), record2_id: "0" }
    });
  }

  // 差し戻し
  private async clickRemand(item: ListItems) {
    if (await this.remand(item)) {
      this.reportList?.clickRemandBtn(item);
    }
  }
}
